// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__YRUcy","loading__icon":"Loading_loading__icon__s0IR8"};